import { render, staticRenderFns } from "./TemplateTasks.vue?vue&type=template&id=689f9d9d&"
import script from "./TemplateTasks.vue?vue&type=script&lang=js&"
export * from "./TemplateTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports